module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN305_157878831.bc00960a.png";